module.exports = __webpack_public_path__ + "static/media/edb.30204e31.png";